/* BOGO records real bottles; the separate original duo retains its existing factor. */
(() => {
  if (customElements.get('co-serum-quantity')) return;
  class SerumQuantity extends HTMLElement {
    connectedCallback() {
      this.unitFactor = Number(this.dataset.unitFactor || 2);
      this.input = this.querySelector('.co-serum-quantity__input');
      if (!this.input || this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', event => {
        if (event.target !== this.input) return;
        event.stopImmediatePropagation();
        this.commit(Number(this.input.value));
      });
      this.querySelectorAll('button[name="plus"],button[name="minus"]').forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault(); event.stopPropagation();
          const amount = Math.max(0, Number(this.input.value) + (button.name === 'plus' ? 2 : -2));
          this.commit(amount);
        });
      });
    }
    commit(bottles) {
      const maximum = this.input.hasAttribute('max') ? Number(this.input.max) : Infinity;
      const controller = this.closest('cart-drawer-items,cart-items');
      if (this.busy || !Number.isInteger(bottles) || bottles < 0 || bottles % 2 || bottles > maximum || typeof controller?.updateQuantity !== 'function') {
        this.input.value = this.dataset.originalBottles; return;
      }
      if (bottles === Number(this.dataset.originalBottles)) return;
      this.busy = true;
      this.input.value = bottles;
      this.querySelector('input.quantity__input').value = bottles / this.unitFactor;
      controller.updateQuantity(this.dataset.line, bottles / this.unitFactor, this.input.name);
      // Native section refresh replaces this component. Allow recovery if its request fails.
      setTimeout(() => {
        if (this.isConnected) {
          this.busy = false;
          this.input.value = this.dataset.originalBottles;
        }
      }, 10000);
    }
  }
  customElements.define('co-serum-quantity', SerumQuantity);
})();
